/**
 *
 * LoginErrorModal
 *
 */

import React from 'react';
import { Link } from 'react-router-dom';
import {
  Wrapper,
  Text,
  PadlockWrapper
} from './styledComponents';

import Modal from 'components/Modal';
import PasswordProblemSVG from 'components/Icon/PasswordProblemSVG';
import H1 from 'components/H1';

const LoginErrorModal = ({ close }) =>  (
  <Modal shakeOnOpen close={close} title='Login Error'>
    <Wrapper>
      <PadlockWrapper>
        <PasswordProblemSVG />
      </PadlockWrapper>
      <H1>
        Need a do-over?
      </H1>
      <Text>
        The email and password combination you are using doesn’t seem to be
        working. If you forgot your password,&nbsp;
        <Link
          to='/forgot-password'
          onClick={() => close()}>
          {"click here to reset it"}
        </Link>
        .
      </Text>
    </Wrapper>
  </Modal>
);

export default LoginErrorModal;



// WEBPACK FOOTER //
// ./src/components/LoginErrorModal/index.js